export default {
  // 边类型描述
  expandEdge: "这是扩展边",
  addressOwnership: "这是地址归属",
  hashNote: "这是哈希备注",
  watchAddress: "这是观察地址",
  sameIpAccount: "同ip账号",
  sameDeviceAccount: "同设备账号",

  // 交易信息标签
  sender: "发送方",
  receiver: "接收方",
  transactionHash: "交易哈希",
  transactionTime: "交易时间",
  transactionQuantity: "交易数量",
  averageQuantity: "平均数量",

  // 注释中的标签（保留用于将来可能的显示）
  currencyName: "币种名称",
  totalQuantity: "总数量",
  totalCount: "总笔数",
  CoinJoin:'混币交易',
};
